import React from 'react';

import "styles/card.scss";
import "./Footer.scss";

const Footer : React.FC = () => {
    return (
    <footer>
        <h3>Links:</h3>
        <ul>
            <li>
                <a href="mailto:devmaxhha@gmail.com">Mail</a>
            </li>
            <li>
                <a href="https://github.com/maxhha">Github</a>
            </li>
        </ul>
    </footer>
    );
}

export default Footer;
